export default __webpack_public_path__ + "static/media/physco1.589538a4.png";